export const channelTalkConstant = {
  pluginKey: process.env.REACT_APP_CHANNEL_TALK_PLUGIN_KEY,
  hideChannelButtonOnBoot: true,
};
